import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "JobCredentialAndBlock/";

const getJobCredentialAndBlocks = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobCredentialAndBlocks?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const saveJobCredentialAndBlock = async (jobCredentialAndBlock) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveJobCredentialAndBlock', jobCredentialAndBlock, constants.REQUIRE_INTERCEPTORS);

const deleteJobCredentialAndBlock = async (id, isOrBlock) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteJobCredentialAndBlock?jobCredentialAndBlockId=' + id + '&isOrBlock=' + isOrBlock, constants.REQUIRE_INTERCEPTORS);

export {
    getJobCredentialAndBlocks,
    saveJobCredentialAndBlock,
    deleteJobCredentialAndBlock
}